import { render, staticRenderFns } from "./ListProxy.vue?vue&type=template&id=94263d34&scoped=true&"
import script from "./ListProxy.vue?vue&type=script&lang=js&"
export * from "./ListProxy.vue?vue&type=script&lang=js&"
import style0 from "./ListProxy.vue?vue&type=style&index=0&id=94263d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94263d34",
  null
  
)

export default component.exports